import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";
import { BookButton, WhatsAppButton, DisclaimerNote } from "../Cta";

const STEPS = [
  { n: "01", t: "Tell me what’s happening", d: "No preparation needed. Just say it honestly, in your own words." },
  { n: "02", t: "We work out what matters now", d: "Not the whole future — what actually needs dealing with today." },
  { n: "03", t: "You leave with the next step", d: "One constructive action you can take with a clearer head." },
];

export const FirstWalk = () => (
  <section id="first-walk" className="mx-auto max-w-6xl px-5 md:px-8 py-24 md:py-36" data-testid="first-walk-section">
    <Chapter n={7} kicker="The First Walk" title="Start here. Thirty minutes, £60." />
    <div className="grid gap-14 md:grid-cols-12 md:gap-10">
      <div className="md:col-span-5">
        <Reveal>
          <p className="font-serif text-6xl md:text-7xl tracking-tighter text-ink" data-testid="first-walk-price">
            £60
          </p>
          <p className="mt-2 text-sm tracking-[0.2em] uppercase text-ink/50">
            30 minutes · Phone call
          </p>
          <p className="mt-8 max-w-md text-base md:text-lg leading-relaxed text-ink/70">
            A low-friction first conversation. You explain what’s happening.
            I’ll help you identify what actually matters right now, offer
            perspective, and help you find the next constructive step. It also
            lets us both decide whether ongoing support would be useful.
          </p>
          <p className="mt-8 max-w-md font-serif text-xl md:text-2xl leading-snug text-ink" data-testid="first-walk-pause-line">
            Sometimes the most important decision is the first one: to pause
            before you act.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <BookButton testid="first-walk-book-cta" />
            <WhatsAppButton testid="first-walk-whatsapp-cta" />
          </div>
          <p className="mt-5 text-sm text-ink/50" data-testid="first-walk-microcopy">
            Book and pay securely online · Choose a time that suits you
          </p>
          <DisclaimerNote className="mt-4" testid="first-walk-disclaimer" />
        </Reveal>
      </div>
      <div className="md:col-span-7">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              className="flex gap-6 border-t border-ink/10 py-7 last:border-b"
              data-testid={`first-walk-step-${s.n}`}
            >
              <span className="font-sans text-sm font-semibold tracking-widest text-pine shrink-0 pt-1.5">{s.n}</span>
              <div>
                <h3 className="font-serif text-xl md:text-2xl text-ink">{s.t}</h3>
                <p className="mt-2 text-base text-ink/60 leading-relaxed">{s.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
